<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-tabs v-model="active" type="border-card" @tab-click="handleClick">
        <el-tab-pane name="1">
          <span slot="label"><i class="el-icon-user-solid"></i> 个人</span>
          <personal />
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label"><i class="el-icon-s-grid"></i> 班级</span>
          <classInfo />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
  import personal from '@/views/fengyiSchool/teacher/components/statistics/personal.vue';
  import classInfo from '@/views/fengyiSchool/teacher/components/statistics/classInfo.vue';
  export default {
    name: 'Statistics',
    components: {
      personal,
      classInfo,
    },
    data() {
      return {
        active: '1',
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
        tab.$children[0].$refs.table.reload();
      },
    },
  };
</script>

<style scoped></style>
